export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

export function blur (str, beginIndex, endIndex) {
  if (!beginIndex || !endIndex) {
    return str
  }
  if (beginIndex > endIndex || beginIndex < 0) {
    return str
  }
  const leftStr = str.substring(0, beginIndex)
  const rightStr = str.substring(endIndex, str.length)
  let result = ''
  try {
    for (let i = 0; i < endIndex - beginIndex; i++) {
      result = result + '*'
    }
  } catch (error) {
    console.log(error)
  }
  result = leftStr + result + rightStr
  return result
}

/**
 * 获取密码强度, level 0:不合格, 1:低, 2:中, >=3:高
 */
export function getStrength (password) {
  let level = 0
  if (!password || password.length < 8) {
    return level
  }
  let mode = 0
  for (let i = 0; i < password.length; i++) {
    const charCode = password.charCodeAt(i)
    let charMode
    if (charCode >= 48 && charCode <= 57) { // 数字
      charMode = 1
    } else if (charCode >= 65 && charCode <= 90) { // 大写
      charMode = 2
    } else if (charCode >= 97 && charCode <= 122) { // 小写
      charMode = 4
    } else {
      charMode = 8
    }
    mode |= charMode
  }
  // 计算密码模式
  level = 0
  for (let i = 0; i < 4; i++) {
    if (mode & 1) { level++ }
    mode >>>= 1
  }
  switch (level) {
    case 0:
      return 'N/A'
    case 1:
      return '低'
    case 2:
      return '中'
    default:
      return '高'
  }
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function convertToPagination (page, pagination) {
  if (page) {
    pagination.current = page.number + 1
    pagination.pageSize = page.size
    pagination.total = page.totalElements
  }
  return pagination
}

export function randomString (e) {
  e = e || 32
  const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const a = t.length
  let n = ''
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}

const CryptoJS = require('crypto-js')

export function encryptPsw (password) {
  const str = CryptoJS.enc.Utf8.parse(password)
  const count = Math.floor(Math.random() * 4 + 1)
  return count + CryptoJS.enc.Base64.stringify(str) + randomString(count)
}

export function encrypt (plaintext) {
  return CryptoJS.AES.encrypt(plaintext, 'grazier').toString()
}

export function decrypt (ciphertext) {
  const bytes = CryptoJS.AES.decrypt(ciphertext, 'grazier')
  return bytes.toString(CryptoJS.enc.Utf8)
}
